<template>
  <b-modal
    id="modal-bv-fgts-offer"
    v-model="show"
    :title="`Enviar Proposta BV FGTS - Lead ${idLead}`"
    hide-footer
    no-close-on-backdrop
    centered
    size="xl"
    @hidden="resetForm"
  >
    <template>
      <b-container>
        <div
          :active-step="activeStep"
          class="bv-offer__step-header"
        >
          <div
            v-for="index in 5"
            :key="index"
            class="bv-offer__step-number bv-offer__step-number--active"
          >
            {{ index }}
          </div>
        </div>

        <div>
        <b-form @submit.prevent="onSubmit">
        <div v-show="activeStep === 1">
          <h3>Simulação</h3>

          <div>
            <b-row>
              <b-col>
                <b-form-group
                  label="CPF"
                  label-for="simulation-cpf-input"
                >
                  <b-form-input
                    id="simulation-cpf-input"
                    v-model="attributes.cpf"
                    v-mask="'###.###.###-##'"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  label="Prestações (opcional)"
                  label-for="periods-input"
                >
                  <b-form-input
                    id="periods-input"
                    v-model="attributes.periods"
                    type="number"
                    min="1"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col></b-col>
              <b-col></b-col>
            </b-row>

            <b-button
              @click="loadSimulation()"
              :disabled="!attributes.cpf"
              class="bv-offer__button"
              pill
            >
              Consultar
            </b-button>
          </div>

          <div
            v-if="isError"
            class="mt-3"
          >
            <span v-if="errorMessage">
              {{ errorMessage }}
            </span>
            <span v-else>
              Ops... ocorreu um erro inesperado. Tente novamente mais tarde.
            </span>
          </div>

          <div
            v-else-if="isLoading"
          >
            <b-row class="justify-content-center m-5">
              <b-spinner class="bv-offer__spinner"></b-spinner>
            </b-row>
          </div>

          <b-row
            v-else-if="simulationTable.length"
            class="mt-4"
          >
            <b-col>
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Data</th>
                    <th>Valor Disponível</th>
                    <th>Valor Desejado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in simulationTable" :key="index">
                    <td>
                      <b-form-checkbox v-model="item.selected"></b-form-checkbox>
                    </td>
                    <td>{{ item.date | date }}</td>
                    <td>R$&nbsp;{{ item.maxValue }}</td>
                    <td>
                      <b-input-group
                        class="bv-offer__input"
                      >
                        <money
                          v-model="item.desiredValue"
                          v-bind="moneyMask"
                          class="form-control flex-fill"
                        ></money>
                      </b-input-group>
                    </td>
                  </tr>
                </tbody>
              </table>

              <b-row class="mt-4 text-left">
                <b-col>
                  <b-button
                    @click="recalculateSimulation()"
                    class="bv-offer__button"
                    pill
                  >
                    Recalcular tabela
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <div v-if="!isEmptySimulationResponse">
                <b-row>
                  <b-col class="bv-offer__simulation__details__header">
                    Detalhamento
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="8" class="bv-offer__simulation__details__label">
                    Valor a antecipar
                  </b-col>
                  <b-col class="bv-offer__simulation__details__value">
                    {{ details.anticipationTotal | currency }}
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="8" class="bv-offer__simulation__details__label">
                    Quantidade a antecipar
                  </b-col>
                  <b-col class="bv-offer__simulation__details__value">
                    {{ details.anticipationPeriodsQuantity | number('integer') }} saques
                  </b-col>
                </b-row>

                <hr>

                <b-row>
                  <b-col class="bv-offer__simulation__details__header">
                    Taxas e Tarifas
                  </b-col>
                </b-row>

                <b-row class="bv-offer__bg-gray">
                  <b-col cols="8" class="bv-offer__simulation__details__label">
                    Tabela de Financiamento
                  </b-col>
                  <b-col class="bv-offer__simulation__details__value">
                    {{ details.financingTable }}
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="8" class="bv-offer__simulation__details__label">
                    Taxas de Juros ao mês
                  </b-col>
                  <b-col class="bv-offer__simulation__details__value">
                    {{ details.monthlyFeePercentage | percentage('pt-BR') }} (a.m.)
                  </b-col>
                </b-row>

                <b-row class="bv-offer__bg-gray">
                  <b-col cols="8" class="bv-offer__simulation__details__label">
                    Taxas de Juros ao ano
                  </b-col>
                  <b-col class="bv-offer__simulation__details__value">
                    {{ details.yearlyFeePercentage | percentage('pt-BR') }} (a.a.)
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="8" class="bv-offer__simulation__details__label">
                    Valor IOF
                  </b-col>
                  <b-col class="bv-offer__simulation__details__value">
                    {{ details.iofValue | currency }}
                    ({{ details.iofPercentage | percentage('pt-BR') }})
                  </b-col>
                </b-row>

                <b-row class="bv-offer__bg-gray">
                  <b-col cols="8" class="bv-offer__simulation__details__label">
                    Valor Tarifa
                  </b-col>
                  <b-col class="bv-offer__simulation__details__value">
                    {{ details.feeValue | currency }}
                    ({{ details.feePercentage | percentage('pt-BR') }})
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="8" class="bv-offer__simulation__details__label">
                    Seguro Renda Protegida Premiada<br>(valor único)
                  </b-col>
                  <b-col class="bv-offer__simulation__details__value">
                    <div>
                      {{ details.insuranceCost | currency('pt-BR') }}
                      ({{ details.insurancePercentage | percentage('pt-BR') }})
                    </div>
                  </b-col>
                </b-row>

                <b-row class="bv-offer__bg-gray">
                  <b-col cols="8" class="bv-offer__simulation__details__label">
                    Custo efetivo total ao mês
                  </b-col>
                  <b-col class="bv-offer__simulation__details__value">
                    {{ details.monthlyTotalEffectiveCost | percentage('pt-BR') }} (a.m.)
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="8" class="bv-offer__simulation__details__label">
                    Custo efetivo total ao ano
                  </b-col>
                  <b-col class="bv-offer__simulation__details__value">
                    {{ details.yearlyTotalEffectiveCost | percentage('pt-BR') }} (a.a.)
                  </b-col>
                </b-row>

                <b-row class="bv-offer__bg-gray">
                  <b-col cols="8" class="bv-offer__simulation__details__label">
                    Valor total financiado<br>(com impostos)
                  </b-col>
                  <b-col class="bv-offer__simulation__details__value">
                    {{ details.totalFinanced | currency }}
                    (100%)
                  </b-col>
                </b-row>

                <hr>

                <b-row>
                  <b-col>
                    Quanto vai receber
                  </b-col>
                  <b-col class="bv-offer__simulation__details__value">
                    {{ detailsNetValue | currency }}
                    ({{ detailsNetValuePercentage | percentage('pt-BR') }})
                  </b-col>
                </b-row>
              </div>

              <div class="mt-4 text-right">
                <b-row>
                  <b-col></b-col>
                  <b-col>
                    <b-form-group
                      label="Cobertura"
                      label-for="insurance-select"
                    >
                      <b-form-select
                        id="insurance-select"
                        v-model="selectedInsurance"
                        :options="insuranceOptions"
                        required
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>

              <div>
                <b-row class="mt-4 mb-4" style="font-size: 12px;">
                  <b-col
                    v-for="(insurance, index) in availableInsurances?.seguros"
                    :key="index"
                  >
                    <span>{{ insurance?.nome }}</span>
                    <span
                      class="bv-offer__text--bold"
                    >
                      {{ insurance?.planoParcelamento?.valorTotalSeguro | currency }}
                    </span>

                    <br><br>

                    <span>Prêmio sorteio</span>
                    <span
                      class="bv-offer__text--bold"
                    >
                      {{ insurance?.planoParcelamento?.valorPremioSorteio | currency }}
                    </span>

                    <br><br>

                    <span>Coberturas</span>
                    <div
                      v-for="(coverage, index) in insurance?.planoParcelamento?.coberturas"
                      :key="index"
                    >
                      <div
                        v-for="(coverageItem, index) in coverage?.item"
                        :key="index"
                      >
                        <span>{{ coverageItem?.descricao }}</span>
                        <span
                          class="bv-offer__text--bold"
                        >
                          R$ {{ coverageItem?.limiteMaximoIdenizacao }}
                        </span>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>

          <div
            v-show="!isEmptySimulationResponse"
            class="mt-4"
          >
            <b-row>
              <b-col class="bv-offer__simulation__details__disclaimer text-right">
                ⚠️ Atenção: é obrigatório mostrar o resumo para o cliente antes de continuar
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-right">
                <b-form-checkbox
                  v-model="attributes.sendCustomerConfirmation"
                  required
                >
                  Confirmo que enviei os detalhes de simulação para o cliente
                </b-form-checkbox>
              </b-col>
            </b-row>
          </div>

          <div>
            <b-row class="mt-4">
              <b-col class="text-right">
                <b-button
                  @click="setNextStepBvForm"
                  :disabled="!attributes?.sendCustomerConfirmation"
                  class="bv-offer__button"
                  pill
                >Próximo</b-button>
              </b-col>
            </b-row>
          </div>
        </div>

        <div v-show="activeStep === 2">
          <h3>Dados pessoais</h3>
          <b-row>
            <b-col>
              <b-form-group
                label="Nome"
                label-for="name-input"
              >
                <b-form-input
                  id="name-input"
                  v-model="attributes.name"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="CPF"
                label-for="personal-cpf-input"
              >
                <b-form-input
                  id="personal-cpf-input"
                  v-model="attributes.cpf"
                  v-mask="'###.###.###-##'"
                  disabled
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Sexo"
                label-for="gender-input"
              >
                <b-form-select
                  id="gender-input"
                  v-model="attributes.gender"
                  :options="['M', 'F']"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Data de nascimento"
                label-for="birth-date-input"
              >
                <b-form-input
                  id="birth-date-input"
                  v-model="attributes.birthDate"
                  type="date"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Nacionalidade"
                label-for="nationality-input"
              >
                <b-form-select
                  id="nationality-input"
                  v-model="attributes.nationality"
                  :options="['Brasileiro', 'Estrangeiro']"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="UF de naturalidade"
                label-for="state-uf-select"
              >
                <b-form-select
                  id="state-uf-select"
                  v-model="attributes.birthState"
                  :options="statesUfList"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Cidade de naturalidade"
                label-for="city-of-birth-input"
              >
                <b-form-input
                  id="city-of-birth-input"
                  v-model="attributes.birthCity"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Estado Civil"
                label-for="civil-status-select"
              >
                <b-form-select
                  id="civil-status-select"
                  v-model="attributes.civilStatus"
                  :options="[
                    { text: 'Solteiro(a)', value: 4 },
                    { text: 'Casado(a)', value: 5 },
                    { text: 'Divorciado(a)', value: 2 },
                    { text: 'Separado(a)', value: 3 },
                    { text: 'Desquitado(a)', value: 1 },
                    { text: 'Viúvo(a)', value: 6 },
                    { text: 'Outros', value: 7 },
                  ]"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="RG (c/ dígito)"
                label-for="rg-input"
              >
                <b-form-input
                  id="rg-input"
                  v-model="attributes.rg"
                  v-mask="'###.###.###-#'"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Órgão Emissor do RG"
                label-for="rg-emitter-input"
              >
                <b-form-input
                  id="rg-emitter-input"
                  v-model="attributes.rgEmitter"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="UF Documento"
                label-for="uf-document-input"
              >
                <b-form-select
                  id="uf-document-input"
                  v-model="attributes.documentState"
                  :options="statesUfList"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Data de emissão"
                label-for="emission-date-input"
              >
                <b-form-input
                  id="emission-date-input"
                  v-model="attributes.emissionDate"
                  type="date"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Nome da mãe"
                label-for="mother-name-input"
              >
                <b-form-input
                  id="mother-name-input"
                  v-model="attributes.motherName"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Email"
                label-for="email-input"
              >
                <b-form-input
                  id="email-input"
                  v-model="attributes.email"
                  type="email"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col></b-col>
          </b-row>
          <div class="d-flex justify-content-between mt-4">
            <b-button
              @click="setPreviousStepBvForm"
              class="bv-offer__button"
              pill
            >
              Anterior
            </b-button>
            <b-button
              @click="setNextStepBvForm"
              :disabled="!isPersonalDataValid"
              class="bv-offer__button"
              pill
            >
              Próximo
            </b-button>
          </div>
        </div>

        <div v-show="activeStep === 3">
          <h3>Endereço</h3>
          <b-row>
            <b-col>
              <b-form-group
                label="CEP"
                label-for="cep-input"
              >
                <b-form-input
                  id="cep-input"
                  v-model="attributes.addressZipcode"
                  v-mask="'##.###-###'"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Estado"
                label-for="state-input"
              >
                <b-form-select
                  id="state-input"
                  v-model="attributes.addressState"
                  :options="statesUfList"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Cidade"
                label-for="city-input"
              >
                <b-form-input
                  id="city-input"
                  v-model="attributes.addressCity"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Endereço"
                label-for="address-input"
              >
                <b-form-input
                  id="address-input"
                  v-model="attributes.address"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Bairro"
                label-for="district-input"
              >
                <b-form-input
                  id="district-input"
                  v-model="attributes.addressDistrict"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Número"
                label-for="address-number-input"
              >
                <b-form-input
                  id="address-number-input"
                  v-model="attributes.addressNumber"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Complemento (opcional)"
                label-for="complement-input"
              >
                <b-form-input
                  id="complement-input"
                  v-model="attributes.addressComplement"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col></b-col>
            <b-col></b-col>
          </b-row>

          <div class="d-flex justify-content-between mt-4">
            <b-button
              @click="setPreviousStepBvForm"
              pill
              class="bv-offer__button"
              >
                Anterior
              </b-button>
            <b-button
              @click="setNextStepBvForm"
              :disabled="!isAddressDataValid"
              pill
              class="bv-offer__button"
              >
                Próximo
              </b-button>
          </div>
        </div>

        <div v-show="activeStep === 4">
          <h3>Dados profissionais</h3>
          <b-row>
            <b-col>
              <b-form-group
                label="Natureza de ocupação"
                label-for="occupation-nature-select"
              >
                <b-form-select
                  id="occupation-nature-select"
                  v-model="attributes.occupationNature"
                  :options="[
                    { text: 'Assalariado', value: 1 },
                    { text: 'Autônomo', value: 3 },
                    { text: 'Liberal', value: 4 },
                    { text: 'Empresário', value: 2 },
                    { text: 'Funcionário público', value: 6 },
                    { text: 'Aposentado ou pensionista', value: 7 },
                    { text: 'Investidor', value: 8 },
                    { text: 'Não definido', value: 0 },
                    { text: 'Outros', value: 5 },
                  ]"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Renda mensal total"
                label-for="total-income-input"
              >
                <b-input-group>
                  <money
                    v-model="attributes.monthlyIncome"
                    v-bind="moneyMask"
                    class="form-control flex-fill"
                  ></money>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col></b-col>
          </b-row>
          <h5>Telefone comercial</h5>
          <b-row>
            <b-col cols="1">
              <b-form-group
                label="DDD"
                label-for="commercial-phone-area-code-input"
              >
                <b-input-group>
                  <b-form-input
                    id="commercial-phone-area-code-input"
                    v-model="attributes.commercialPhoneAreaCode"
                    v-mask="'##'"
                    required
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Telefone comercial"
                label-for="commercial-phone-number-input"
              >
                <b-input-group>
                  <b-form-input
                    id="commercial-phone-number-input"
                    v-model="attributes.commercialPhoneNumber"
                    v-mask="'#########'"
                    required
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Ramal (opcional)"
                label-for="commercial-phone-extension-input"
              >
                <b-input-group>
                  <b-form-input
                    id="commercial-phone-extension-input"
                    v-model="attributes.commercialPhoneExtension"
                    v-mask="'#########'"
                    required
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col></b-col>
            <b-col></b-col>
          </b-row>
          <div class="d-flex justify-content-between mt-4">
            <b-button
              @click="setPreviousStepBvForm"
              class="bv-offer__button"
              pill
            >
              Anterior
            </b-button>
            <b-button
              @click="setNextStepBvForm"
              :disabled="!isProfessionalDataValid"
              class="bv-offer__button"
              pill
            >
              Próximo
            </b-button>
          </div>
        </div>

        <div v-show="activeStep === 5">
          <h3>Dados bancários</h3>
          <b-row>
            <b-col>
              <b-form-group
                label="Nome do Favorecido"
                label-for="account-holder-input"
              >
                <input
                  id="account-holder-input"
                  v-model="attributes.accountHolder"
                  type="text"
                  required
                  class="bv-offer__input--vanilla"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="CPF"
                label-for="bank-cpf-input"
              >
                <b-form-input
                  id="bank-cpf-input"
                  v-model="attributes.cpfBank"
                  v-mask="'###.###.###-##'"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Valor do crédito"
                label-for="credit-value-input"
              >
                <b-form-input
                  id="credit-value-input"
                  v-model="detailsNetValue"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Código do Banco"
                label-for="bank-input"
              >
                <b-form-input
                  id="bank-input"
                  v-model="attributes.bank"
                  v-mask="'###'"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Tipo de conta"
                label-for="account-type-select"
              >
                <b-form-select
                  id="account-type-select"
                  v-model="attributes.accountType"
                  :options="[
                    { text: 'Corrente', value: 'C' },
                    { text: 'Poupança', value: 'P' },
                  ]"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <b-form-group
                label="Agência (sem dígito)"
                label-for="agency-input"
              >
                <b-form-input
                  id="agency-input"
                  v-model="attributes.agencyNumber"
                  v-mask="'######'"
                  required
              ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group
                label="Dígito(s) da agência"
                label-for="agency-digit-input"
              >
                <b-form-input
                  id="agency-digit-input"
                  v-model="attributes.agencyDigit"
                  v-mask="'###'"
                required
              ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Conta"
                label-for="account-number-input"
              >
                <b-form-input
                  id="account-number-input"
                  v-model="attributes.accountNumber"
                  v-mask="'############'"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Dígito(s) da conta"
                label-for="account-number-input"
              >
                <b-form-input
                  id="account-number-input"
                  v-model="attributes.accountDigit"
                  v-mask="'###'"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="mt-4">
            <b-row>
              <b-col class="d-flex justify-content-end">
                <b-form-checkbox
                  v-model="attributes.reviewConfirmation"
                  required
                >
                  Confirmo que revisei as informações e elas estão corretas
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col class="d-flex justify-content-between">
                <b-button
                  @click="setPreviousStepBvForm"
                  class="bv-offer__button"
                  pill
                >
                  Anterior
                </b-button>
                <b-button
                  @click="submitBvForm"
                  :disabled="
                    !isBankDataValid
                    || !attributes?.reviewConfirmation
                  "
                  class="bv-offer__button"
                  pill
                >
                  <span
                    v-if="isLoadingSubmit"
                  >
                    <b-spinner
                      small
                    ></b-spinner>
                  </span>
                  <span>
                    Enviar Proposta
                  </span>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
        </b-form>
        </div>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import ModalMessageApp from "@/components/ModalMessageApp.vue";
import DateRangePicker from "vue2-daterange-picker";
import vSelect from "vue-select";
import { mapState, mapGetters } from "vuex";
import axios from 'axios'
import { dateFilter, percentageFilter, currencyFilter, numberFilter } from "@/utils/filters";
import { Money } from "v-money";

export default {
  name: 'WidgetMultiStepFormModalBV',

  components: {
    LayoutDefault,
    DateRangePicker,
    vSelect,
    ModalMessageApp,
    Money,
  },

  props: {
    value: Boolean,
    idLead: {
      type: [Number, String],
    },
  },

  filters: {
    date: dateFilter,
    percentage: percentageFilter,
    currency: currencyFilter,
    number: numberFilter,
  },

  computed: {
    ...mapState('base', ['mainApi']),
    ...mapGetters('auth', ['allowedFeature']),

    show: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      }
    },

    isEmptySimulationResponse() {
      return !this.simulationResponse?.data;
    },

    detailsAnticipationTotal() {
      return this.simulationResponse?.data?.valorTotal || 0;
    },

    detailsAnticipationPeriodsQuantity() {
      return this.simulationResponse?.data?.periodos?.length || 0;
    },

    detailsIofPercentage() {
      return this.detailsAnticipationTotal
        ? this.simulationResponse?.data?.valorIOF / this.detailsAnticipationTotal * 100
        : 0;
    },

    detailsFeePercentage() {
      return this.detailsAnticipationTotal
        ? this.simulationResponse?.data?.tarifaValor / this.detailsAnticipationTotal * 100
        : 0;
    },

    detailsInsuranceCost() {
      return this.selectedInsuranceCost || 0;
    },

    detailsInsurancePercentage() {
      return this.detailsAnticipationTotal
        ? this.detailsInsuranceCost / this.detailsAnticipationTotal * 100
        : 0;
    },

    detailsTotalFinanced() {
      let total = 0;
      total += this.detailsNetValue || 0;
      total += this.detailsInsuranceCost || 0;
      total += this.simulationResponse?.data?.valorIOF || 0;
      return total;
    },

    detailsNetValue() {
      if (!this.simulationResponse?.data?.valorLiquido) return 0;

      const insuranceCost = this.detailsInsuranceCost || 0;
      const netValue = this.simulationResponse?.data?.valorLiquido - insuranceCost

      return parseFloat(netValue.toFixed(2));
    },

    detailsNetValuePercentage() {
      return this.detailsTotalFinanced
        ? this.detailsNetValue / this.detailsTotalFinanced * 100
        : 0;
    },

    details() {
      return {
        anticipationTotal: this.detailsAnticipationTotal,
        anticipationPeriodsQuantity: this.detailsAnticipationPeriodsQuantity,
        financingTable: this.simulationResponse?.data?.tabelaFinanc,
        monthlyFeePercentage: this.simulationResponse?.data?.txNetBv,
        yearlyFeePercentage: this.simulationResponse?.data?.txJurosAno,
        iofValue: this.simulationResponse?.data?.valorIOF,
        iofPercentage: this.detailsIofPercentage,
        feeValue: this.simulationResponse?.data?.tarifaValor,
        feePercentage: this.simulationResponse?.data?.tarifaValor,
        insuranceCost: this.detailsInsuranceCost,
        insurancePercentage: this.detailsInsurancePercentage,
        monthlyTotalEffectiveCost: this.simulationResponse?.data?.txCETMes,
        yearlyTotalEffectiveCost: this.simulationResponse?.data?.txCETAno,
        totalFinanced: this.detailsTotalFinanced,
      };
    },

    insuranceOptions() {
      if (!this.simulationResponse?.data?.cobertura?.seguros?.length) return [];

      const options = [];

      options.push({
        text: 'Sem seguro',
        value: 0,
      })

      for (const insurance of this.simulationResponse?.data?.cobertura?.seguros) {
        options.push({
          text: insurance?.nome,
          value: insurance?.planoParcelamento?.valorTotalSeguro,
        });
      }

      return options;
    },

    isPersonalDataValid() {
      let isValid = this.attributes.name
        && this.attributes.cpf
        && this.attributes.gender
        && this.attributes.birthDate
        && this.attributes.nationality
        && this.attributes.birthState
        && this.attributes.birthCity
        && this.attributes.civilStatus
        && this.attributes.rg
        && this.attributes.rgEmitter
        && this.attributes.documentState
        && this.attributes.emissionDate
        && this.attributes.motherName
        && this.attributes.email;

      return isValid;
    },

    isAddressDataValid() {
      let isValid = this.attributes.addressZipcode
        && this.attributes.addressState
        && this.attributes.addressCity
        && this.attributes.address
        && this.attributes.address.length < 25
        && this.attributes.addressDistrict
        && this.attributes.addressNumber;

      return isValid;
    },

    isProfessionalDataValid() {
      let isValid = this.attributes.occupationNature
        && this.attributes.monthlyIncome
        && this.attributes.commercialPhoneAreaCode
        && this.attributes.commercialPhoneNumber;

      return isValid;
    },

    isBankDataValid() {
      let isValid = this.attributes.accountHolder
        && this.attributes.cpfBank
        && this.attributes.accountType
        && this.attributes.bank
        && this.attributes.agencyNumber
        && (this.attributes.agencyDigit || this.attributes.agencyDigit === 0)
        && this.attributes.accountNumber
        && (this.attributes.accountDigit || this.attributes.accountDigit === 0);

      return isValid;
    },
  },

  data() {
    return {
      moneyMask: {
        prefix: "",
        suffix: "",
        precision: 2,
        masked: true
      },

      activeStep: 1,
      simulationPayload: {},
      simulationResponse: {},
      simulationResponseTable: [],
      simulationTable: [],
      attributes: {},
      payload: {},

      hasInsurance: false,
      availableInsurances: {},
      selectedInsurance: {},
      selectedInsuranceCost: 0,

      isLoading: false,
      isLoadingSubmit: false,
      isError: false,
      errorMessage: "",

      statesUfList: [
        "AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"
      ],
    };
  },

  methods: {
    resetLoading() {
      this.isError = false;
      this.isLoading = true;
    },

    async loadSimulation() {
      try {
        this.resetLoading();

        this.simulationPayload = {
          cpf: String(this.attributes?.cpf).replace(/[-.]/g, ''),
          periods: parseInt(this.attributes?.periods) || 10,
        };

        const response = await axios.post(`${this.mainApi}integration-bv/get-simulation/true`,
          this.simulationPayload,
          {
          headers: {
            'Authorization': `Bearer ${this.$auth.token()}`
          }
        });

        if (response?.data?.status === 'error') {
          this.isError = true;
          this.errorMessage = response?.data?.data;
          return;
        }

        this.simulationResponse = response?.data;
        this.simulationTable = [];

        for (const period of this.simulationResponse?.data?.periodos) {
          this.simulationTable.push({
            selected: true,
            date: period.dataRepasse,
            maxValue: period.valor,
            desiredValue: period.valor,
          })
        }

        this.availableInsurances = this.simulationResponse?.data?.cobertura;

      } catch (err) {
        this.isError = true;
        console.error(err);
        console.log(err?.response?.data?.data?.message)
      } finally {
        this.isLoading = false;
      }
    },

    convertDateToPayload(date) {
      return date.split('-').reverse().join('/');
    },

    convertMaskToFloat(number) {
      return parseFloat(String(number).replace(/,/g, ''));
    },

    async recalculateSimulation() {
      if (!this.simulationTable.length) return;

      try {
        this.resetLoading();

        const periodsPayload = [];

        for (const period of this.simulationTable) {
          if (period.selected) {
            periodsPayload.push({
              valor: this.convertMaskToFloat(period?.desiredValue),
              dataRepasse: this.convertDateToPayload(period?.date),
              parcelaValida: period?.selected,
            });
          }
        }

        this.simulationPayload = {
          cpf: String(this.attributes?.cpf).replace(/[-.]/g, ''),
          preSetPeriods: periodsPayload,
        };

        const response = await axios.post(`${this.mainApi}integration-bv/get-simulation/true`,
          this.simulationPayload,
          {
          headers: {
            'Authorization': `Bearer ${this.$auth.token()}`
          }
        });

        this.simulationResponse = response?.data;

        this.availableInsurances = this.simulationResponse?.data?.cobertura;

      } catch (err) {
        this.isError = true;
        console.error(err);
        alert(err.response?.data?.error?.cause?.message || 'Ocorreu um erro não identificado ao solicitar a oferta.')
      } finally {
        this.isLoading = false;
      }
    },

    setNextStepBvForm() {
      this.activeStep++;
    },

    setPreviousStepBvForm() {
      this.activeStep--;
    },

    setActiveStep(index) {
      this.activeStep = index;
    },

    buildPayload() {
      try {
        const date = new Date();

        const simulationIrregularFlow = [];

        for (let i = 0; i < this.simulationTable?.length; i++) {
          if (this.simulationTable[i].selected) {
            simulationIrregularFlow.push({
              dataRepasse: this.convertDateToPayload(this.simulationTable[i].date),
              valor: this.convertMaskToFloat(this.simulationTable[i].desiredValue),
            });
          }
        }

        let simulationInsurancePayload = {};

        if (this.selectedInsuranceCost) {
          const insuranceResponseObj = this.simulationResponse?.data?.cobertura?.seguros[0];

          simulationInsurancePayload = {
            codigoSimulacao: this.simulationResponse?.data?.cobertura?.codigoSimulacao,
            codigoCotacao: insuranceResponseObj.planoParcelamento?.codigoCotacao,
            valorTotalSeguro: this.selectedInsuranceCost,
          };
        }

        this.payload = {
          leadId: this.idLead,
          purpose: {
            loginUsuario: "Weclever",
            operador: 50098,
            codigoFilialComercial: 274,
            codigoVeiculoLegal: 1,
            dadosPagamento: {
              agencia: String(this.attributes?.agencyNumber),
              dvAgencia: String(this.attributes?.agencyDigit),
              banco: String(this.attributes?.bank),
              conta: `${this.attributes.accountNumber}${this.attributes.accountDigit}`,
              nome: String(this.attributes?.accountHolder),
              numeroCpfCnpj: String(this.attributes?.cpfBank)?.replace(/[-.]/g, ''),
              tipoConta: this.attributes?.accountType,
              tipoPagamento: "4",
              valor: this.convertMaskToFloat(this.detailsNetValue),
            },
            dataEntradaProposta: date.toLocaleDateString('pt-BR'),
            fluxoIrregular: simulationIrregularFlow,
            modalidade: 77,
            parceiroComercial: "",
            numeroPropostaParceiro: "",
            agenteCertificado: {
              codigo: 3547101,
              nomeCompleto: "AGENTE MOCK",
            },
            pessoas: [
              {
                dadosPessoaFisica: {
                  dadosProfissionais: {
                    nomeEmpresa: "",
                    qtdeMesesOcupacao: 0,
                    telefoneComercial: {
                      ddd: String(this.attributes?.commercialPhoneAreaCode),
                      numero: String(this.attributes?.commercialPhoneNumber)?.replace(/\-/g, ''),
                      tipo: 2,
                      ramal: String(this.attributes?.commercialPhoneExtension || ""),
                      recebeSms: 'N',
                    },
                  },
                  dataNascimento: this.convertDateToPayload(this.attributes?.birthDate),
                  documentoIdentificacao: {
                    dataEmissao: this.convertDateToPayload(this.attributes?.emissionDate),
                    nomeOrgaoEmissor: this.attributes?.rgEmitter,
                    numeroDocumento: this.attributes?.rg?.replace(/\./g, ''),
                    tipoDocumentoIdentificacao: 1,
                    unidadeFederacaoEmissao: this.attributes?.documentState,
                  },
                  estadoCivil: this.attributes?.civilStatus,
                  idade: parseInt(this.calculateAge(this.attributes?.birthDate)),
                  nacionalidade: this.attributes?.nationality,
                  ufNaturalidade: this.attributes?.birthState,
                  naturalidade: this.attributes?.birthCity,
                  nomeMae: this.attributes?.motherName,
                  tipoProfissional: this.attributes?.occupationNature,
                  profissao: 125,
                  qtdeMesesResidencia: 0,
                  sexo: this.attributes?.gender,
                  tipoFontePagadora: 1,
                  tipoResidencia: 4,
                  valorPatrimonio: 0,
                  valorRenda: this.convertMaskToFloat(this.attributes?.monthlyIncome),
                },
                emails: [
                  {
                    endereco: this.attributes?.email,
                  },
                ],
                enderecos: [
                  {
                    bairro: this.attributes?.addressDistrict,
                    cep: this.attributes?.addressZipcode.replace(/[-.]/g, ''),
                    cidade: this.attributes?.addressCity,
                    complemento: this.attributes?.addressComplement || "",
                    correspondencia: true,
                    logradouro: this.attributes?.address,
                    numero: String(this.attributes?.addressNumber),
                    tipo: 1,
                    uf: this.attributes?.addressState,
                  },
                ],
                nome: this.attributes?.name,
                numeroCpfCnpj: this.attributes?.cpf.replace(/[-.]/g, ''),
                papelPessoa: 1,
                telefones: [],
                tipoPessoa: "F",
              },
            ],
            tipoMeioVenda: 10,
            produto: 10,
            subProduto: 100,
            tabelaFinanciamento: "",
            tipoCobranca: 8,
            valorProposta: this.convertMaskToFloat(this.detailsAnticipationTotal),
            logDossie: {
              numeroPropostaParceiroComercial: "1",
              dataOcorrencia: date?.toISOString(),
              descricaoFusoHorario: Intl.DateTimeFormat().resolvedOptions().timeZone,
              codigoEventoConexaoParceiro: 208,
              nomeSistemaOperacional: navigator?.platform,
              nomeNavegadorInternet: navigator?.userAgent,
            }
          }
        }

        if (Object.keys(simulationInsurancePayload).length) {
          this.payload.purpose = {
            ...this.payload.purpose,
            dadosSeguro: simulationInsurancePayload,
          };
        }
      } catch (err) {
        console.error(err);
        alert('Ocorreu um erro inesperado processando os campos informados.');
        throw new Error('Error trying to build the payload!');
      }
    },

    calculateAge(birthDateStr) {
      const today = new Date();
      const birthDate = new Date(birthDateStr);
      let age = today.getFullYear() - birthDate.getFullYear();
      const month = today.getMonth() - birthDate.getMonth();
      if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },

    async postPurpose() {
      try {
        this.buildPayload();

        const response = await axios.post(`${this.mainApi}integration-bv/create-purpose/`,
          this.payload,
          {
          headers: {
            'Authorization': `Bearer ${this.$auth.token()}`
          }
        });
      } catch (err) {
        console.error(err);
        let errorMessage = "Ocorreu um erro inesperado chamando a API de integração da BV.";
        if (err?.response?.data?.data?.error?.cause?.message) {
          errorMessage = err.response.data.data.error.cause.message;
        }
        alert(errorMessage);
        throw new Error(errorMessage);
      }
    },

    async tabulateStatus() {
      if (!this.idLead) return;

      const statusPayload = {
        channel: "App",
        status: {
          id_status: 56,
          name: "input",
          label: "Input",
        },
        tabulation: {
          name: "Input",
          description: "Input",
        },
      };

      const response = await axios.post(`${this.mainApi}lead/${this.idLead}/history/`,
        statusPayload,
        {
        headers: {
          'Authorization': `Bearer ${this.$auth.token()}`
        }
      });
    },

    resetForm() {
      this.activeStep = 1;
      this.attributes = {};
      this.payload = {};
      this.simulationPayload = {};
      this.simulationResponse = {};
      this.simulationTable = [];
      this.availableInsurances = {};
      this.selectedInsurance = {};
      this.selectedInsuranceCost = 0;
    },

    async submitBvForm() {
      this.isLoadingSubmit = true;

      try {
        await this.postPurpose();
        alert('Oferta enviada com sucesso!');

        await this.tabulateStatus();
        alert('Lead tabulado com sucesso!');
      } catch (err) {
        console.error(err);
        throw new Error(err);
      } finally {
        this.isLoadingSubmit = false;
      }

      this.resetForm();
      this.show = false;
      this.emitSuccessMessage();
    },

    emitSuccessMessage() {
      this.$emit('offer-success', 'Proposta enviada com sucesso!');
    },

  },

  watch: {
    hasInsurance(newVal) {
      if (!newVal) {
        this.selectedInsurance = {};
        this.selectedInsuranceCost = 0;
      }
    },

    selectedInsurance(newVal) {
      this.selectedInsuranceCost = newVal || 0;
    },
  },
}
</script>

<style scoped lang="scss">
$blue-dark: nth($colors-custom, 1);
$blue-light: nth($colors-custom, 2);
$gray-light: nth($colors-custom, 4);

td {
  vertical-align: middle;
}

.bv-offer {
  &__title {
    font-size: 1.5em;
    font-weight: bold;
    margin-bottom: 1em;
  }

  &__simulation {
    &__details {
      &__disclaimer {
        font: {
          size: 16px;
          weight: bold;
        }
        margin: 0 0 20px 0;
      }

      &__header {
        font: {
          size: 22px;
          weight: bold;
        }
      }

      &__label {
        font: {
          size: 16px;
        }
      }

      &__value {
        text-align: right;
        font: {
          size: 16px;
        }
      }
    }
  }

  &__form {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }

  &__step-header {
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 100%;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      height: 2px;
      background-color: $gray-light;
      z-index: 0;
      transform: translate(0, -12px);
    }
  }

  &__step-number {
    position: relative;
    z-index: 1;
    border-radius: 50%;
    background-color: $gray-light;
    color: #172542;
    font-size: 1.5em;
    height: 2em;
    line-height: 2em;
    margin-bottom: 1em;
    text-align: center;
    width: 2em;
    cursor: pointer;
    &--active {
      cursor: default;
      background-color: $blue-light;
      color: #fff;
    }
  }

  &__input {
    width: 150px;

    &--vanilla {
      display: block;
      width: 100%;
      height: calc(1.5em + 0.75rem + 2px);
      padding: 0.375rem 0.75rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
      transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
      outline: none;

      &:focus {
        border: 1px solid $blue-light;
        box-shadow: 0 0 0 0.1rem $blue-light;
      }
    }

    &--invalid {
      border: 2px solid red;
    }
  }

  &__text {
    &--bold {
      font-weight: bold;
    }
  }

  &__bg-gray {
    background-color: $gray-light;
  }

  &__button {
    background-color: $blue-dark;
  }

  &__spinner {
    width: 3rem;
    height: 3rem;
  }
}
</style>
